import { useEffect, useMemo, useState } from 'react'
import { api } from '../api/client.js'
import { plural } from '../lib/format.js'
import CaseCard from '../components/CaseCard.jsx'
import CategoryTabs from '../components/CategoryTabs.jsx'
import '../styles/home.css'

export default function Home() {
  const [cases, setCases] = useState(null)
  const [categories, setCategories] = useState([])
  const [selectedCat, setSelectedCat] = useState('all')

  useEffect(() => {
    api
      .cases()
      .then((data) => {
        setCases(data.cases)
        setCategories(data.categories)
      })
      .catch(() => setCases([]))
  }, [])

  const groups = useMemo(() => {
    if (!cases) return []
    const baseCats = selectedCat === 'all' 
      ? categories.filter((cat) => cat.id !== 'all')
      : categories.filter((cat) => cat.id === selectedCat)

    return baseCats
      .map((cat) => ({
        ...cat,
        items: cases.filter((item) => item.category === cat.id),
      }))
      .filter((group) => group.items.length > 0)
  }, [cases, categories, selectedCat])

  return (
    <div className="page storefront-page container">

      {/* Табы категорий */}
      {cases && cases.length > 0 && categories.length > 0 && (
        <div className="storefront-tabs-wrapper">
          <CategoryTabs
            categories={categories}
            cases={cases}
            value={selectedCat}
            onChange={setSelectedCat}
          />
        </div>
      )}

      {cases === null ? (
        <div className="case-grid">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="case-card-skeleton" />
          ))}
        </div>
      ) : cases.length === 0 ? (
        <div className="case-empty-state">
          <div className="empty-box-icon" aria-hidden="true">📦</div>
          <h3 className="empty-title">Кейсы пока не добавлены</h3>
          <p className="empty-subtitle muted">Скоро здесь появятся новые кейсы для открытия!</p>
        </div>
      ) : (
        groups.map((group) => (
          <div key={group.id} className="cat-group">
            <div className="cat-group-head">
              <div className="cat-head-decor cat-head-decor-left">
                <span className="cat-head-line" />
              </div>

              <div className="cat-head-center">
                <h2 className="cat-head-title">{group.label}</h2>
                <span className="cat-head-count">
                  <span className="cat-head-count-num">{group.items.length}</span>
                  <svg
                    className="cat-case-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    width="16"
                    height="16"
                    aria-hidden="true"
                  >
                    <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
                    <path d="m3.3 7 8.7 5 8.7-5" />
                    <path d="M12 22V12" />
                  </svg>
                </span>
              </div>

              <div className="cat-head-decor cat-head-decor-right">
                <span className="cat-head-line" />
              </div>
            </div>

            <div className="case-grid">
              {group.items.map((caseData) => (
                <CaseCard key={caseData.id} caseData={caseData} />
              ))}
            </div>
          </div>
        ))
      )}
    </div>
  )
}
